import { combineReducers } from 'redux';
import { exchange } from './exchange';

const rootReducer = combineReducers({
    exchange,
});
export default rootReducer;
